<template>
  <div class="setting_box">
    <div class="spinner-box mask" v-if="loading">
      <div class="pulse-container">
        <div class="pulse-bubble pulse-bubble-1"></div>
        <div class="pulse-bubble pulse-bubble-2"></div>
        <div class="pulse-bubble pulse-bubble-3"></div>
      </div>
    </div>
    <div class="setting_left">
      <div class="right_div" @click="closeArea">
        <img class="icon" src="@/assets/img/left.png" />
        <p class="title">返回</p>
      </div>
      <div class="video_show" @click="toShowEdit">
        <img class="img" src="@/assets/ss/soft.jpg" />
        <div class="edit_fun">
          <p class="title">{{ rowData.channel_name }}</p>
          <img class="icon" src="@/assets/img/edit.png" />
        </div>
      </div>
      <div class="share_info">
        <div class="share_content">
          <div class="name">共享人数</div>
          <div class="num">0</div>
        </div>
        <div class="share_content">
          <div class="name">授权人数</div>
          <div class="num">0</div>
        </div>
      </div>
    </div>
    <div class="setting_right">
      <div class="setting_fun_title">
        <div class="fun">
          设备详情
        </div>
        <div class="fun on">
          布防设置
        </div>
      </div>
      <div class="setting_fun_box">
        <ul class="setting_fun_area">
          <li class="setting_fun_area_li">
            <div class="setting_fun_area_div">
              <div class="name">
                移动检测
              </div>
              <div class="desc">
                开启后，检测到画面变化时将录制视频，默认为"7*24"小时的提醒
              </div>
            </div>
            <div class="setting_fun_area_switch">
              <Switched :defaultChecked="true" v-model="checked" checkedInfo="开" uncheckedInfo="关" :disabled="false"
                style="margin-top: 15px;" />
            </div>
          </li>
          <li class="setting_fun_area_li">
            <div class="setting_fun_area_div">
              <div class="name">
                布防时间段
              </div>
            </div>
            <div class="setting_fun_area_switch">
              <div class="btn">
                设置
              </div>
            </div>
          </li>
          <li class="setting_fun_area_li" v-if="is_click">
            <div class="setting_fun_area_div">
              <div class="name">
                动检灵敏度
              </div>
            </div>
            <div class="setting_fun_area_switch">
              <select v-model="stall" class="setting_fun_area_select">
                <option :value="item" :selected="item == stall ? 'true' : 'false'" v-for="item in 5">{{ item }}
                  {{ item == 3 ? '默认' : '' }} </option>
              </select>
            </div>
          </li>
          <li class="setting_fun_area_li">
            <div class="setting_fun_area_div">
              <div class="name">
                动检区域
              </div>
            </div>
            <div class="setting_fun_area_switch" @click="showSetArea">
              <div class="btn">
                选择区域
              </div>
            </div>
          </li>
        </ul>
      </div>
    </div>
    <SettingAreaCmp v-if="hasAreaSetting" :videoInfo="rowData" :rowData="row" :columnData="column"
      :regionData="region" @onClose="closeSetArea" />
    <div class="function_area_loading" v-if="loading"></div>
    <div class="edit_name_box" v-if="showEdit">
      <div class="edit_name_content">
        <div class="shurukuang">
          <input v-model="editName" placeholder="请输入设备名称" />
          <button @click="toEidtName">保存</button>
        </div>
        <div class="close" @click="toCloseEdit">
          <img src="../../assets/img/close.png" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import eventCommon from './eventCommon.js';
import axios from 'axios';
import Switched from './../Switched/Switched';
import SettingAreaCmp from './SettingAreaCmp';
export default {
  name: 'SettingCmp',
  components: {
    Switched, SettingAreaCmp
  },
  data() {
    return {
      checked: true,
      hasAreaSetting: false,
      row: 0,
      column: 0,
      stall: 0,
      region: '',
      loading: false,
      showEdit: false,
      editName: '',
      is_click: ''
    }
  },
  props: {
    rowData: {
      type: [Object, Array],
      default: function () {
        return [];
      }
    }
  },
  watch: {
    rowData(newValue, oldValue) {
      this.getAreaInfo(newValue);
    }
  },
  mounted() {
    this.getAreaInfo(this.rowData);
  },
  methods: {
    getAreaInfo(data) {
      let _this = this;
      if (_this.loading) return;
      _this.loading = true;
      axios.get(_this.$store.state.base_url + 'Monitor_Center/getDeviceAlarmParam?channel_id=' + data.channel_id + '&device_code=' + data.device_code).then(function (response) {
        _this.loading = false;
        if (response.status === 200 && response.data.code == 1) {
          if (response.data.data.is_click) {
            _this.row = response.data.data.row;
            _this.column = response.data.data.column;
            _this.stall = response.data.data.stall;
            _this.region = response.data.data.region;
            _this.is_click = true;
          } else {
            _this.is_click = false;
          }
        } else {
          _this.swalToast(response.data.info);
        }
      }).catch(function (error) {
        _this.loading = false;
      }).finally(function () { });
    },
    closeArea() {
      this.$emit('onClose');
    },
    showSetArea() {
      let is_click = this.is_click;
      if (!is_click) {
        return this.swalToast('该设备暂时不支持此功能！');
      }
      this.hasAreaSetting = true;
    },
    closeSetArea(e) {
      this.hasAreaSetting = false;
      if (e.data == 1) {
        this.getAreaInfo(this.rowData);
      }
    },
    toShowEdit() {
      this.showEdit = true;
      this.editName = this.rowData.channel_name
    },
    toCloseEdit() {
      this.showEdit = false;
      this.editName = '';
    },
    toEidtName() {
      let editName = this.editName;
      if (!editName) {
        return this.swalToast('名称不能为空！');
      }
      let oldName = this.rowData.channel_name;
      if (oldName == editName) {
        return this.swalToast('名称没有被修改！');
      }
      let _this = this;
      if (_this.loading) return;
      _this.loading = true;
      let device_code = _this.rowData.device_code;
      let channel_id = _this.rowData.channel_id;
      axios.post(_this.$store.state.base_url + 'Monitor_Center/setDeviceName', {
        device_code, channel_id, device_name: editName
      }).then(function (response) {
        _this.loading = false;
        if (response.status === 200 && response.data.code == 1) {
          _this.toCloseEdit();
          eventCommon.$emit('onEditDeviceName', {
            device_code, channel_id, device_name: response.data.data.name, channel_name: editName
          })
        } else {
          _this.swalToast(response.data.info);
        }
      }).catch(function (error) {
        _this.loading = false;
      }).finally(function () { });
    },
    swalToast(message, icon = 'warning') {
      this.$swal({
        position: 'center',
        icon: icon,
        title: message,
        showConfirmButton: false,
        timer: 3000
      });
    }
  }
}
</script>

<style scoped>
.setting_box {
  width: 100%;
  height: 100%;
  position: absolute;
  z-index: 99;
  top: 0;
  left: 0;
  background: #0b1120;
  display: flex;
}

.setting_box .setting_left {
  width: 360px;
  height: 100%;
  background: #0f172a;
  border-right: 1px solid #1e293b;
  display: flex;
  flex-direction: column;
  flex-shrink: 0;
}

.setting_box .setting_left .right_div {
  padding: 16px 20px;
  display: flex;
  align-items: center;
  gap: 8px;
  cursor: pointer;
  transition: opacity 0.3s;
}

.setting_box .setting_left .right_div:hover {
  opacity: 0.8;
}

.setting_box .setting_left .right_div .icon {
  width: 20px;
  height: 20px;
  opacity: 0.7;
}

.setting_box .setting_left .right_div .title {
  font-size: 15px;
  font-weight: 500;
  color: #e2e8f0;
}

.setting_box .setting_left .edit_fun {
  margin: 0 auto;
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 12px 0;
}

.setting_box .setting_left .video_show {
  width: 100%;
  text-align: center;
  padding: 0 20px;
}

.setting_box .setting_left .video_show .img {
  width: 100%;
  max-width: 300px;
  border-radius: 8px;
  border: 1px solid #1e293b;
}

.setting_box .setting_left .video_show .title {
  color: #e2e8f0;
  font-size: 14px;
  font-weight: 500;
  line-height: 22px;
}

.setting_box .setting_left .video_show .icon {
  width: 16px;
  height: 16px;
  opacity: 0.5;
  cursor: pointer;
  transition: opacity 0.3s;
}

.setting_box .setting_left .video_show .icon:hover {
  opacity: 1;
}

.setting_box .setting_right {
  height: 100%;
  flex: 1;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.setting_left .share_info {
  padding: 20px;
  margin-top: auto;
  border-top: 1px solid #1e293b;
}

.setting_left .share_info .share_content {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 6px 0;
}

.setting_left .share_info .share_content .name {
  color: #94a3b8;
  font-size: 13px;
  font-weight: 400;
}

.setting_left .share_info .share_content .num {
  color: #e2e8f0;
  font-size: 14px;
  font-weight: 600;
}

.setting_right .setting_fun_title {
  display: flex;
  padding: 16px 24px;
  gap: 8px;
  flex-shrink: 0;
}

.setting_right .setting_fun_title .fun {
  text-align: center;
  padding: 8px 24px;
  font-size: 13px;
  font-weight: 500;
  color: #94a3b8;
  background: #1e293b;
  border: 1px solid #334155;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.3s;
}

.setting_right .setting_fun_title .fun.on {
  background: rgba(59, 130, 246, 0.15);
  border-color: #3b82f6;
  color: #3b82f6;
}

.setting_right .setting_fun_box {
  flex: 1;
  overflow-y: auto;
  padding: 0 24px;
}

.setting_fun_area {
  padding: 0;
  box-sizing: border-box;
}

.setting_fun_box .setting_fun_area_div {
  flex: 1;
  padding: 16px 0;
}

.setting_fun_box .setting_fun_area_div .name {
  font-size: 15px;
  font-weight: 500;
  color: #e2e8f0;
  line-height: 22px;
}

.setting_fun_box .setting_fun_area_div .desc {
  margin-top: 4px;
  font-size: 12px;
  color: #64748b;
  line-height: 18px;
}

.setting_fun_box .setting_fun_area_switch {
  flex-shrink: 0;
  margin-left: 16px;
}

.setting_fun_area_li {
  padding: 0 16px;
  border-bottom: 1px solid #1e293b;
  display: flex;
  align-items: center;
  justify-content: space-between;
  transition: background 0.3s;
}

.setting_fun_area_li:hover {
  background: rgba(59, 130, 246, 0.05);
}

.setting_fun_area_switch .btn {
  text-align: center;
  padding: 6px 20px;
  font-size: 13px;
  font-weight: 500;
  background: rgba(59, 130, 246, 0.15);
  border: 1px solid #3b82f6;
  border-radius: 6px;
  color: #3b82f6;
  cursor: pointer;
  transition: all 0.3s;
}

.setting_fun_area_switch .btn:hover {
  background: rgba(59, 130, 246, 0.25);
}

.setting_fun_area_select {
  padding: 0 12px;
  width: 120px;
  height: 36px;
  font-size: 13px;
  line-height: 36px;
  background: #1e293b;
  border: 1px solid #334155;
  border-radius: 6px;
  color: #e2e8f0;
  cursor: pointer;
}

.function_area_loading {
  width: 100%;
  height: 100%;
  position: absolute;
  z-index: 202;
  top: 0;
  left: 0;
}

.spinner-box.mask {
  margin-top: 20px;
  background-color: transparent;
  transform: scale(1.3);
}

.edit_name_box {
  position: absolute;
  z-index: 2;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, .6);
  display: flex;
  align-items: center;
  justify-content: center;
}

.edit_name_box .edit_name_content {
  width: 400px;
}

.edit_name_content .shurukuang {
  background: #1e293b;
  border: 1px solid #334155;
  text-align: center;
  padding: 40px 32px;
  border-radius: 12px;
}

.edit_name_content .shurukuang input {
  width: 100%;
  height: 48px;
  font-size: 15px;
  line-height: 48px;
  background: #0f172a;
  border: 1px solid #334155;
  border-radius: 8px;
  text-align: center;
  color: #e2e8f0;
  padding: 0 16px;
  transition: border-color 0.3s;
}

.edit_name_content .shurukuang input:focus {
  border-color: #3b82f6;
}

.edit_name_content .shurukuang input::placeholder {
  color: #64748b;
}

.edit_name_content .shurukuang button {
  margin-top: 24px;
  width: 100%;
  height: 44px;
  font-size: 14px;
  font-weight: 500;
  line-height: 44px;
  text-align: center;
  background: #3b82f6;
  color: white;
  border: none;
  border-radius: 8px;
  cursor: pointer;
  transition: background 0.3s;
}

.edit_name_content .shurukuang button:hover {
  background: #2563eb;
}

.edit_name_content .close {
  width: 56px;
  height: 56px;
  margin: 16px auto 0;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.1);
  cursor: pointer;
  transition: background 0.3s;
}

.edit_name_content .close:hover {
  background: rgba(255, 255, 255, 0.2);
}

.edit_name_content .close img {
  width: 24px;
  height: 24px;
}
</style>
